import React, {ReactElement} from 'react'
import {Nullable} from '../../../../app/TypeHelpers';
import {StyledDiv, StyledLi, StyledOl, StyledSpan} from '../../../../styledComponents/StyledTypeDefinitions';
import styled from 'styled-components';
import {BreakPoint, Colors, FontSize} from '../../../../styledComponents/Constants';
import {generateMedia} from 'styled-media-query';

export enum Step {
    POLICY,
    AUTHENTICATION_KEY,
    HASEKO_ID_CONFIRM,
    MAIL_ADDRESS_REGISTER,
    MAIL_RECEIVE,
    SUB_USER_REGISTER,
    SUB_USER_CONFIRM,
    SUTEKI_NET_PASSWORD_CONFIRM,
    HASEKO_ID_PASSWORD_CONFIRM,
    USER_REGISTER,
    USER_CONFIRM,
    MAIL_ADDRESS_INPUT,
    MAIL_SEND,
    RESETTING,
    COMPLETE,
}

export interface DIspStepInfo {
    policy?: boolean
    authenticationKey?: boolean;
    hasekoIdConfirm?: boolean;
    mailAddressRegister?: boolean;
    mailReceive?: boolean;
    subUserRegister?: boolean;
    subUserConfirm?: boolean;
    sutekiNetPasswordConfirm?: boolean;
    hasekoIdPasswordConfirm?: boolean;
    userRegister?: boolean;
    userConfirm?: boolean;
    reSetting?: boolean;
    mailAddressInput?: boolean;
    mailSend?: boolean;
    complete?: boolean;
}

interface Props {
    dIspStepInfo: DIspStepInfo
    nowStep: Step
}

interface StepInfo {
    text1: string,
    text2: string,
    step: number
}

export default class NatStepComponent extends React.Component<Props> {
    lastStep: number;

    constructor(props: Props) {
        super(props);

        this.lastStep = Step.COMPLETE;
    }

    renderStep(datas: StepInfo): Nullable<ReactElement> {
        // 完了
        if (datas.step === Step.COMPLETE) {
            // 現在のSTEPが、完了の場合
            if (datas.step === this.props.nowStep) {
                return (
                    <ListStepNowComplate>
                        <ListStepComplateBodyWrapper>
                            <StepSpan>
                                {datas.text1}
                            </StepSpan>
                            {(datas.text2 !== '') ?
                                <StepSpan>
                                    {datas.text2}
                                </StepSpan> : ''}
                        </ListStepComplateBodyWrapper>
                    </ListStepNowComplate>
                );
            } else {
                return (
                    <ListStepComplate>
                        <ListStepComplateBodyWrapper>
                            <StepSpan>
                                {datas.text1}
                            </StepSpan>
                            {(datas.text2 !== '') ?
                                <StepSpan>
                                    {datas.text2}
                                </StepSpan> : ''}
                        </ListStepComplateBodyWrapper>
                    </ListStepComplate>
                );
            }
        } else {
            if (datas.step === this.lastStep &&
                datas.step === this.props.nowStep) {
                // 最終STEP
                return (
                    <ListStepFinishNow>
                        <ListStepBodyWrapper>
                            <StepSpan>
                                {datas.text1}
                            </StepSpan>
                            {(datas.text2 !== '') ?
                                <StepSpan>
                                    {datas.text2}
                                </StepSpan> : ''}
                        </ListStepBodyWrapper>
                    </ListStepFinishNow>
                );
            } else if (datas.step === this.lastStep) {
                // 最終STEP
                return (
                    <ListStepFinish>
                        <ListStepBodyWrapper>
                            <StepSpan>
                                {datas.text1}
                            </StepSpan>
                            {(datas.text2 !== '') ?
                                <StepSpan>
                                    {datas.text2}
                                </StepSpan> : ''}
                        </ListStepBodyWrapper>
                    </ListStepFinish>
                );
                // 現在のSTEP
            } else if (datas.step === this.props.nowStep) {
                return (
                    <ListStepNow>
                        <ListStepBodyWrapper>
                            <StepSpan>
                                {datas.text1}
                            </StepSpan>
                            {(datas.text2 !== '') ?
                                <StepSpan>
                                    {datas.text2}
                                </StepSpan> : ''}
                        </ListStepBodyWrapper>
                    </ListStepNow>
                );
                // 後STEP
            } else if (datas.step > this.props.nowStep) {
                return (
                    <ListStepNext>
                        <ListStepBodyWrapper>
                            <StepSpan>
                                {datas.text1}
                            </StepSpan>
                            {(datas.text2 !== '') ?
                                <StepSpan>
                                    {datas.text2}
                                </StepSpan> : ''}
                        </ListStepBodyWrapper>
                    </ListStepNext>
                );
                // 前STEP
            } else {
                return (
                    <ListStepBefore>
                        <ListStepBeforeBodyWrapper>
                            <StepSpan>
                                {datas.text1}
                            </StepSpan>
                            {(datas.text2 !== '') ?
                                <StepSpan>
                                    {datas.text2}
                                </StepSpan> : ''}
                        </ListStepBeforeBodyWrapper>
                    </ListStepBefore>
                );
            }
        }
    }

    // Stepデータ設定
    setStepData(): StepInfo[] {
        const stepData: StepInfo[] = [];

        // 利用規約
        if (this.props.dIspStepInfo.policy) {
            stepData.push(
                {
                    text1: '利用規約',
                    text2: '',
                    step: Step.POLICY,
                },
            )
        }
        if (this.props.dIspStepInfo.authenticationKey) {
            stepData.push(
                {
                    text1: '認証キー',
                    text2: '入力',
                    step: Step.AUTHENTICATION_KEY,
                },
            )
        }
        if (this.props.dIspStepInfo.hasekoIdConfirm) {
            stepData.push(
                {
                    text1: '長谷工ID',
                    text2: '確認',
                    step: Step.HASEKO_ID_CONFIRM,
                },
            )

        }
        if (this.props.dIspStepInfo.mailAddressRegister) {
            stepData.push(
                {
                    text1: 'メールアドレス',
                    text2: '登録',
                    step: Step.MAIL_ADDRESS_REGISTER,
                },
            )
        }
        if (this.props.dIspStepInfo.mailReceive) {
            stepData.push(
                {
                    text1: 'メール受信',
                    text2: '',
                    step: Step.MAIL_RECEIVE,
                },
            )
        }
        if (this.props.dIspStepInfo.subUserRegister) {
            stepData.push(
                {
                    text1: 'サブユーザ',
                    text2: '情報登録',
                    step: Step.SUB_USER_REGISTER,
                },
            )

        }
        if (this.props.dIspStepInfo.subUserConfirm) {
            stepData.push(
                {
                    text1: 'サブユーザ',
                    text2: '情報確認',
                    step: Step.SUB_USER_CONFIRM,
                },
            )
        }
        if (this.props.dIspStepInfo.sutekiNetPasswordConfirm) {
            stepData.push(
                {
                    text1: 'パスワード確認',
                    text2: '',
                    step: Step.SUTEKI_NET_PASSWORD_CONFIRM,
                },
            )
        }
        if (this.props.dIspStepInfo.hasekoIdPasswordConfirm) {
            stepData.push(
                {
                    text1: 'パスワード確認',
                    text2: '',
                    step: Step.HASEKO_ID_PASSWORD_CONFIRM,
                },
            )
        }
        if (this.props.dIspStepInfo.userRegister) {
            stepData.push(
                {
                    text1: 'ユーザ情報',
                    text2: '登録',
                    step: Step.USER_REGISTER,
                },
            )
        }
        if (this.props.dIspStepInfo.userConfirm) {
            stepData.push(
                {
                    text1: 'ユーザ情報',
                    text2: '確認',
                    step: Step.USER_CONFIRM,
                },
            )
        }
        if (this.props.dIspStepInfo.mailAddressInput) {
            stepData.push(
                {
                    text1: 'メールアドレス入力',
                    text2: '',
                    step: Step.MAIL_ADDRESS_INPUT,
                },
            )
        }
        if (this.props.dIspStepInfo.mailSend) {
            stepData.push(
                {
                    text1: 'メール送信',
                    text2: '',
                    step: Step.MAIL_SEND,
                },
            )
        }
        if (this.props.dIspStepInfo.reSetting) {
            stepData.push(
                {
                    text1: '再設定',
                    text2: '',
                    step: Step.RESETTING,
                },
            )
        }
        if (this.props.dIspStepInfo.complete) {
            stepData.push(
                {
                    text1: '完了',
                    text2: '',
                    step: Step.COMPLETE,
                },
            )
        }

        return stepData;
    }


    render(): ReactElement {
        const stepData: StepInfo[] = this.setStepData();
        if (Object.keys(stepData).length) {
            this.lastStep = stepData.reduce((a, b) => a.step > b.step ? a : b).step;
        }

        return (
            <div>
                <ListStep>
                    {
                        stepData.map((data, index) => (
                            <StepDiv key={index}>
                                {this.renderStep(data)}
                            </StepDiv>
                        ))
                    }
                </ListStep>
            </div>
        )
    }
}

const customMedia: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
});

const ListStep: StyledOl = styled.ol`
  margin: 30px 0 15px 0;
  overflow: hidden;
  text-align: center;
  padding: 0;

  ${customMedia.greaterThan('sp')`
    div:first-child > li{
     margin: 0 0 5px 0;
    }
  `}


  ${customMedia.lessThan('sp')`
     margin-bottom: 32px;
     overflow: hidden;
  `}
`;

// STEP(base)
const BaseStep: StyledLi = styled.li`
  display: table;
  background: ${Colors.Primary};
  color: ${Colors.Surface};
  position: relative;
  list-style: none;
  padding-left: 0;
  float: left;
  width: 155px;
  height: 56px;
  margin: 0 0 5px 25px;

  &::after {
    border-left: 20px solid ${Colors.Primary};
    border-top: 28px solid transparent;
    border-bottom: 28px solid transparent;
    content: "";
    position: absolute;
    left: 50%;
    top: 0;
    margin-left: 77px;
    }

  ${customMedia.lessThan('sp')`
    margin: 0 auto 15px;
    width: 100%;
    height: 40px;
    position: relative;

    &::after {
      border-top: 18px solid ${Colors.Primary};
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      content: "";
      position: absolute;
      bottom: -40px;
      left: 50%;
      margin-left: -16px;
      top: initial;;
      z-index: 5;
    }
  `}
`;

// 現在のSTEP
const ListStepNow = styled(BaseStep)`
  background-color: ${Colors.Surface};
  color: ${Colors.Primary};

  &::before {
     border-left: 11px solid ${Colors.Surface};
     border-top: 28px solid transparent;
     border-bottom: 28px solid transparent;
     content: "";
     position: absolute;
     left: 50%;
     top: 6px;
     z-index: 5;
     border-bottom-width: 23px;
     border-top-width: 22px;
     margin-left: 77px;
    }

  ${customMedia.lessThan('sp')`
  &::after {
    bottom: -42px;
  }
  &::before {
      border-top: 16px solid ${Colors.Surface};
      border-left: 13px solid transparent;
      border-right: 13px solid transparent;
      content: "";
      position: absolute;
      bottom: -31px;
      left: 50%;
      margin-left: -14px;
      top: initial;;
      z-index: 6;
  }
  `}
`;

// 後STEP
const ListStepNext = styled(BaseStep)`
  background-color: ${Colors.Primary};
  color: ${Colors.Surface};
`;

// 前STEP
const ListStepBefore = styled(BaseStep)`
  background-color: ${Colors.PrimaryComplete};
  color: ${Colors.Surface};

  &::after {
    border-left: 20px solid ${Colors.PrimaryComplete};
  }

  ${customMedia.lessThan('sp')`
  &::after {
    border-top: 14px solid ${Colors.PrimaryComplete};
    border-left: 15px solid transparent;;
  }
  `}
`;

// 最終STEP
const ListStepFinish = styled(BaseStep)`
  background-color: ${Colors.Primary};
  color: ${Colors.Surface};

  ${customMedia.lessThan('sp')`
  &::after {
    content: none;
  }
  `}
`;

// 最終STEP（現在）
const ListStepFinishNow = styled(ListStepNow)`
  ${customMedia.lessThan('sp')`
  &::after {
    content: none;
  }
  &::before {
    content: none;
  }
  `}
`;

// 完了STEP(現在)
const ListStepNowComplate = styled(BaseStep)`
  background-color: ${Colors.Surface};
  color: ${Colors.Primary};

  &::after {
    content: none;
  }
`;

// 完了STEP
const ListStepComplate = styled(BaseStep)`
  background-color: ${Colors.Primary};
  color: ${Colors.Surface};

  &::after {
    content: none;
  }
`;

// STEPテキストWrapper（base）
const BaseListStepBodyWrapper: StyledDiv = styled.div`
  display: table-cell;
  width: 100%;
  height: 44px;
  font-size:  ${FontSize.Middle};
  line-height: 1.1;
  vertical-align: middle;
  text-align: center;

  ${customMedia.lessThan('sp')`
    height: 28px;
  `}
`;

// STEPテキストWrapper
const ListStepBodyWrapper = styled(BaseListStepBodyWrapper)`
  display: table-cell;
  border-color: ${Colors.Primary};
  border-width: 6px 0 6px 6px;
  border-style: solid;
  padding: 0 10px 0 16px;

  ${customMedia.lessThan('sp')`
    border-width: 4px;
    padding: 0 16px;
  `}
`;

// STEPテキストWrapper（前STEP）
const ListStepBeforeBodyWrapper = styled(BaseListStepBodyWrapper)`
  padding: 0 10px 0 16px;
`;

// STEPテキストWrapper（完了STEP）
const ListStepComplateBodyWrapper = styled(BaseListStepBodyWrapper)`
  border: 6px solid ${Colors.Primary};
  padding: 0;

  ${customMedia.lessThan('sp')`
    border-style: solid;
  `}
`;

// STEPテキスト
const StepSpan: StyledSpan = styled.span`
  display: inline-block;
`;

// STEPテキスト（完了STEP）
const StepDiv: StyledDiv = styled.div`
  display: inline-block;

  ${customMedia.lessThan('sp')`
    display: block;
  `}
`;
